import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useGetTmeslotsQuery,
  useDeleteTimeslotMutation,
} from "slices/common/timeslotSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Timeslots() {
  const naviagte = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteTimeslotMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetTmeslotsQuery({
    page,
    limit,
    search,
  });
  const col = [
    {
      display: "City Name",
      key: "cat",
      type: "display", // optional if you want to distinguish types
      render: (row) => <>{row.location?.cityName || "-"}</>,
    },
    { display: "Day", key: "day", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Settings", "Timeslots", "edit");
  const canDelete = hasActionAccess(auth, "Settings", "Timeslots", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };
  const onEdit = (row) => {
    naviagte(
      `/settings/timeslots/update-timeslots/${row._id}/${row.location._id}`
    );
  };

  const handleAdd = () => {
    naviagte("/settings/timeslots/add-timeslots");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this slot?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Settings", "Timeslots", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Timeslot
        </Button>
      )}

      <Tables
        title={"Timeslots"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Timeslots;
